<template>
  <div class="inputs-block">
    <div class="row">
      <div class=" col-lg-3 col-sm-12 col-xs-12 text-log-line">
        <h1 class="header">{{ 'Operating States' | i18n }}</h1>
      </div>
      <div class=" col-lg-5 col-sm-12 col-xs-12 input-log-line"></div>
    </div>
    <div class="row input-line align-items-center" v-for="v in isPowerPlant ? PowerPlant : UpstreamPlant" :key="v.name">
      <div class=" col-lg-3 col-sm-12 col-xs-12 text-log-line d-flex align-items-center">
        {{ v.name | i18n }}
      </div>
      <div class=" col-lg-5 col-sm-12 col-xs-12 input-log-line" v-if="value[v.name]">
        <Radio
          v-model="value[v.name].value"
          :viewMode="!isMyTeam"
          :options="options"
          :formGroupId="v.name + 'select'"
        />
      </div>
      <div class=" col-lg-4 col-sm-12 col-xs-12 input-log-line" v-if="value[v.name]">
        <Input v-model="value[v.name].comment" :viewMode="!isMyTeam" placeholder="Comments" :formGroupId="v.name" />
      </div>
    </div>
    <div class="row input-line" v-if="isPowerPlant">
      <div class=" col-lg-3 col-sm-12 col-xs-12 text-log-line d-flex align-items-center">
        {{ 'Changeover RMB' | i18n }}
      </div>
      <div class=" col-lg-2 col-sm-12 col-xs-12 text-log-line">
        <DateTime v-model="value['Changeover RMB'].value" :disabled="!isMyTeam" type="time" placeholder="Time" required />
      </div>
    </div>
    <div class="row input-line">
      <div class=" col-lg-3 col-sm-12 col-xs-12 text-log-line d-flex align-items-center">
        {{ 'Comment' | i18n }}
      </div>
      <div class=" col-lg-9 col-sm-12 col-xs-12 input-log-line">
        <Textarea
          v-model="value['Comment'].value"
          :viewMode="!isMyTeam"
          placeholder="Comment"
          formGroupId="Comment"
          rows="2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlockHeader from '../../../../common/block-header';
import Radio from '../../../../common/radio';
import Input from '../../../../common/input';
import DateTime from '../../../../common/date-time';
import Textarea from '../../../../common/textarea';

export default {
  title: 'Shift Staff',
  components: { BlockHeader, Radio, Input, DateTime, Textarea },
  props: {
    isMyTeam: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {}
    },
    isPowerPlant: {
      type: Boolean
    },
    isUpstreamPlant: {
      type: Boolean
    }
  },
  data() {
    return {
      UpstreamPlant: [
        { name: 'Crane CKA East' },
        { name: 'Crane CKA West' },
        { name: 'Road Delivery' },
        { name: 'Crane TMB East' },
        { name: 'Crane TMB West' },
        { name: 'Household Waste Line 1' },
        { name: 'Household Waste Line 2' },
        { name: 'Sorting Residue Line 1' },
        { name: 'Sorting Residue Line 2' },
        { name: 'Bunker Belt 1' },
        { name: 'Bunker Belt 2' },
        { name: 'Crane RAB East' },
        { name: 'Crane RAB West' }
      ],
      PowerPlant: [
        { name: 'Boiler 1' },
        { name: 'Boiler 2' },
        { name: 'Boiler 3' },
        { name: 'Boiler 4' },
        { name: 'Turbo Unit 1' },
        { name: 'Turbo Unit 2' },
        { name: 'Steam Extraction' },
        { name: 'Crane RMB East' },
        { name: 'Crane RMB West' }
      ],
      options: [
        { value: 'Operating', text: this.$translate('Operating') },
        { value: 'Not Operating', text: this.$translate('Not Operating') },
        { value: 'Repair', text: this.$translate('Repair') }
      ]
    };
  },
  created() {
    this.UpstreamPlant.forEach(v => {
      if (!this.value[v.name]) {
        this.value[v.name] = {
          value: null,
          comment: ''
        };
      }
    });
    this.PowerPlant.forEach(v => {
      if (!this.value[v.name]) {
        this.value[v.name] = {
          value: null,
          comment: ''
        };
      }
    });
    if (!this.value['Comment']) {
      this.value['Comment'] = {
        value: ''
      };
    }
    if (this.isPowerPlant && (!this.value['Changeover RMB'] || !this.value['Changeover RMB'].value)) {
      this.value['Changeover RMB'] = {
        value: ''
      };
    }
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.header {
  color: #5f5f5f !important;
  font-size: 1.6rem !important;
  font-weight: 400;
  text-transform: uppercase;
  margin: 0;
}
.height100 {
  height: 100%;
}
.inputs-block {
  margin-bottom: 50px;
}
.input-line {
  padding: 10px 0;
  margin: 10px 0;
  box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
  .form-group {
    margin-bottom: 0px;
  }
}
</style>
